import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=1bc3eb6c&scoped=true&"
import script from "./EmployeeCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=1bc3eb6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3eb6c",
  null
  
)

export default component.exports